<template>
    <section class="border-l border-gray flex flex-col bg-white">
        <product-header class="cz-hidden lg:flex" />

        <step-progress />

        <accordion-list class="cz-hidden lg:block flex-grow overflow-y-auto" />

        <swiper-list class="lg:cz-hidden" />

        <div class="border-t border-gray flex justify-center lg:gap-5 lg:py-3 lg:px-10 bg-white">
            <save-button v-if="!isFromCart"
                :class="{
                    'w-1/2': !isFromCart
                }"
            />

            <add-to-cart-button
                :update-mode="isFromCart"
                @click="openList"
                :class="{
                    'w-1/2': !isFromCart
                }"
            />
        </div>

        <view-all-list
            v-if="isMobile && !selectionsComplete"
            :is-open="showOverlay"
            @overlayClose="showOverlay = false"
        />
    </section>
</template>

<script>
    import allStores from '../stores/all';

    import ProductHeader from './ProductHeader.vue';
    import StepProgress from './StepProgress.vue';
    import AccordionList from './AccordionList.vue';
    import SwiperList from './SwiperList.vue';
    import SaveButton from './SaveButton.vue';
    import AddToCartButton from './AddToCartButton.vue';
    import ViewAllList from './ViewAllList.vue';

    export default {
        mixins: [allStores],

        components: {
            ProductHeader,
            StepProgress,
            AccordionList,
            SwiperList,
            SaveButton,
            AddToCartButton,
            ViewAllList,
        },

        data() {
            return {
                showOverlay: false,
            };
        },

        computed: {
            selectionsComplete() {
                return this.customizerStore.selectionsComplete;
            },

            isMobile() {
                return this.appStore.isMobile;
            },

            isFromCart() {
                return this.customizerStore.isFromCart;
            },
        },

        methods: {
            openList() {
                if (this.isMobile && !this.selectionsComplete) {
                    this.showOverlay = true;
                }
            },
        },
    };
</script>
